import styled from 'styled-components';

const detailTableStyled = styled.div`
  .tab-panel {
    height: 37vh;
  }
`;
export default detailTableStyled;
